module.exports = __webpack_public_path__ + "static/media/Img_22.2d89219e.JPG";